const OPEN_WIZARD = 'viewDesigns/wizard/OPEN_WIZARD';
const HIDE_WIZARD = 'viewDesigns/wizard/HIDE_WIZARD';
const NEXT = 'viewDesigns/wizard/NEXT';
const PREV = 'viewDesigns/wizard/PREV';
const FIRST = 'viewDesigns/wizard/FIRST';
const WELCOME = 'viewDesigns/wizard/WELCOME';
const ADD_UPDATE_IMAGE = 'viewDesigns/wizard/UPDATE_IMAGE';
const SET_TITLE = 'viewDesigns/wizard/SET_TITLE';
const SET_WAIT_FOR_CUSTOMIZED = 'viewDesigns/wizard/SET_WAIT_FOR_CUSTOMIZED';
const SET_CUSTOMIZED = 'viewDesigns/wizard/SET_CUSTOMIZED';
const SET_DONT_SHOW_ME_AGAIN = 'viewDesigns/wizard/SET_DONT_SHOW_ME_AGAIN';
const SET_ROLLER_OFFSET = 'viewDesigns/wizard/SET_ROLLER_OFFSET';
const SET_FIRST_CUSTOMIZED_READY = 'viewDesigns/wizard/SET_FIRST_CUSTOMIZED_READY';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case OPEN_WIZARD:
      return {
        ...state,
        wizardOpen: true
      };
    case HIDE_WIZARD:
      return {
        ...state,
        wizardOpen: false
      };
    case NEXT:
      return {
        ...state,
        step: (state.step + 1)
      };
    case PREV:
      return {
        ...state,
        step: state.step - 1
      };
    case FIRST:
      return {
        ...state,
        step: 0
      };
    case WELCOME:
      return {
        ...state,
        step: -1
      };
    case ADD_UPDATE_IMAGE:
      const newState = {...state};
      if (action.index >= state.nextImageIndex) { // new image
        newState.nextImageIndex = action.index + 1;
      }
      newState.images = {
        ...state.images,
        [action.index]: {...state.images[action.index], ...action.update, index: action.index}
      };
      return newState;

    case SET_TITLE:
      return {
        ...state,
        title: action.title
      };
    case SET_WAIT_FOR_CUSTOMIZED:
      return {
        ...state,
        waitForCustomized: action.waitForCustomized
      };
    case SET_CUSTOMIZED:
      return {
        ...state,
        customized: action.customized
      };
    case SET_DONT_SHOW_ME_AGAIN:
      return {
        ...state,
        dontShowMeAgain: action.dontShowMeAgain
      };
    case SET_ROLLER_OFFSET:
      return {
        ...state,
        rollerOffset: action.rollerOffset
      };
    case SET_FIRST_CUSTOMIZED_READY:
      return {
        ...state,
        firstCustomizedReady: action.firstCustomizedReady
      };
    default:
      return state;
  }
}

export function hideWizard() {
  return {type: HIDE_WIZARD};
}

export function openWizard() {
  return {type: OPEN_WIZARD};
}

export function next() {
  return {type: NEXT};
}

export function prev() {
  return {type: PREV};
}

export function first() {
  return {type: FIRST};
}

export function welcome() {
  return {type: WELCOME};
}

export function addUpdateImage(index, update) {
  return {type: ADD_UPDATE_IMAGE, index: index, update: update};
}

export function deleteImage(image) {
  return {type: ADD_UPDATE_IMAGE, index: image.index, update: {deleted: true}};
}

export function setTitle(title) {
  return {type: SET_TITLE, title: title};
}

export function setWaitForCustomized(waitForCustomized) {
  return {type: SET_WAIT_FOR_CUSTOMIZED, waitForCustomized: waitForCustomized};
}

export function setCustomized(customized) {
  return {type: SET_CUSTOMIZED, customized: customized};
}

export function setDontShowMeAgain(dontShowMeAgain) {
  return {type: SET_DONT_SHOW_ME_AGAIN, dontShowMeAgain: dontShowMeAgain};
}

export function setRollerOffset(rollerOffset) {
  return {type: SET_ROLLER_OFFSET, rollerOffset: rollerOffset};
}

export function setFirstCustomizedReady(firstCustomizedReady) {
  return {type: SET_FIRST_CUSTOMIZED_READY, firstCustomizedReady: firstCustomizedReady};
}
